/*
 * Copyright (c) 2023. Word Wide Generation Ltd
 */

export const TODO_QUERY_PARAM = 'todoOpen';
